import type {
  UpsertAgentMutation,
  UpsertAgentMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const UPSERT_AGENT: TypedDocumentNode<
  UpsertAgentMutation,
  UpsertAgentMutationVariables
> = gql`
  mutation UpsertAgent($input: UpsertAgentInput!) {
    upsertAgent(input: $input) {
      message
      agent {
        id
        userId
        name
        cron
        processorId
        parameters
        enabled
        createdAt
        updatedAt
      }
    }
  }
`;
